import { Outlet } from "react-router-dom";
import { AppSidebar } from "./AppSidebar";

export function AppLayout() {
  return (
    <div className="flex h-screen bg-white">
      <aside className="w-64 border-r bg-white">
        <AppSidebar />
      </aside>
      <main className="flex-1 flex flex-col overflow-auto bg-white">
        <div className="flex-1 overflow-auto">
          <Outlet />
        </div>
      </main>
    </div>
  );
}